// extracted by mini-css-extract-plugin
module.exports = {"TransformerTable":"TransformerTable__TransformerTable___2GRvO"};